"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React, { useState } from "react";
import Image from "next/image";
import { motion, AnimatePresence } from "framer-motion";
import { allInOneFeatures } from "./crm.data";
const ease = [0.17, 0.85, 0.438, 0.99] as const;

/**
 * "All-in-One Practice Management Solution for Doctors and Clinics"
 * Tab switcher — one feature panel visible at a time, text left / image right.
 */
export default function SplitSections() {
  const $ = _c(76);
  const desktopAnimations = useDesktopAnimations();
  const [activeId, setActiveId] = useState(allInOneFeatures[0].id);
  let T0;
  let T1;
  let active;
  let t0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== activeId || $[1] !== desktopAnimations) {
    active = allInOneFeatures.find(f => f.id === activeId) ?? allInOneFeatures[0];
    t14 = "overflow-hidden bg-white px-6 py-16 font-sans md:py-24 dark:bg-gray-900";
    t11 = "mx-auto w-full max-w-7xl";
    let t15;
    if ($[20] !== desktopAnimations) {
      t15 = desktopAnimations ? {
        opacity: 0,
        y: 40
      } : false;
      $[20] = desktopAnimations;
      $[21] = t15;
    } else {
      t15 = $[21];
    }
    let t16;
    if ($[22] !== desktopAnimations) {
      t16 = desktopAnimations ? {
        opacity: 1,
        y: 0
      } : undefined;
      $[22] = desktopAnimations;
      $[23] = t16;
    } else {
      t16 = $[23];
    }
    let t17;
    if ($[24] !== desktopAnimations) {
      t17 = desktopAnimations ? undefined : {
        opacity: 1,
        y: 0
      };
      $[24] = desktopAnimations;
      $[25] = t17;
    } else {
      t17 = $[25];
    }
    let t18;
    let t19;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = {
        duration: 0.6,
        ease
      };
      t19 = {
        once: true
      };
      $[26] = t18;
      $[27] = t19;
    } else {
      t18 = $[26];
      t19 = $[27];
    }
    let t20;
    if ($[28] !== t15 || $[29] !== t16 || $[30] !== t17) {
      t20 = <motion.h2 initial={t15} whileInView={t16} animate={t17} transition={t18} viewport={t19} className="font-poppins mb-5 text-[1.9rem] font-bold leading-tight text-[#141047] sm:text-[2.25rem] lg:text-[2.5rem] dark:text-white">All-in-One Practice Management Solution for Doctors and Clinics</motion.h2>;
      $[28] = t15;
      $[29] = t16;
      $[30] = t17;
      $[31] = t20;
    } else {
      t20 = $[31];
    }
    let t21;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = <p className="text-base leading-[1.75] text-gray-500 dark:text-gray-400">A complete system to manage appointments, patient records, queues, billing, and clinic tasks smoothly and efficiently.</p>;
      $[32] = t21;
    } else {
      t21 = $[32];
    }
    if ($[33] !== t20) {
      t12 = <div className="mx-auto mb-9 max-w-3xl text-center">{t20}{t21}</div>;
      $[33] = t20;
      $[34] = t12;
    } else {
      t12 = $[34];
    }
    let t22;
    if ($[35] !== activeId) {
      t22 = allInOneFeatures.map(feature => {
        const isActive = feature.id === activeId;
        return <button key={feature.id} type="button" onClick={() => setActiveId(feature.id)} aria-pressed={isActive} className={`cursor-pointer rounded-full border px-6 py-2.5 text-[15px] transition-all duration-300 ${isActive ? "border-transparent bg-[#00a6f0] text-white shadow-[0_8px_20px_-8px_rgba(0,166,240,0.7)]" : "border-[#e6e9f0] bg-white text-[#5b6b7d] hover:border-[#00a6f0] hover:text-[#141047] dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:text-white"}`}>{feature.navLabel}</button>;
      });
      $[35] = activeId;
      $[36] = t22;
    } else {
      t22 = $[36];
    }
    if ($[37] !== t22) {
      t13 = <div className="mb-14 flex flex-wrap items-center justify-center gap-3">{t22}</div>;
      $[37] = t22;
      $[38] = t13;
    } else {
      t13 = $[38];
    }
    T1 = AnimatePresence;
    t10 = "wait";
    T0 = motion.div;
    t4 = active.id;
    if ($[39] !== desktopAnimations) {
      t5 = desktopAnimations ? {
        opacity: 0,
        y: 20
      } : false;
      $[39] = desktopAnimations;
      $[40] = t5;
    } else {
      t5 = $[40];
    }
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        opacity: 1,
        y: 0
      };
      t7 = {
        opacity: 0,
        y: 10
      };
      t8 = {
        duration: 0.35,
        ease
      };
      $[41] = t6;
      $[42] = t7;
      $[43] = t8;
    } else {
      t6 = $[41];
      t7 = $[42];
      t8 = $[43];
    }
    t9 = "grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16";
    t2 = "order-2 flex flex-col justify-center lg:order-1";
    t3 = <h3 className="font-poppins mb-8 text-[1.75rem] font-bold leading-tight text-[#141047] sm:text-[2rem] lg:text-[2.35rem] dark:text-white">{active.heading}</h3>;
    t0 = "space-y-5";
    t1 = active.points.map(_temp);
    $[0] = activeId;
    $[1] = desktopAnimations;
    $[2] = T0;
    $[3] = T1;
    $[4] = active;
    $[5] = t0;
    $[6] = t1;
    $[7] = t10;
    $[8] = t11;
    $[9] = t12;
    $[10] = t13;
    $[11] = t14;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    T0 = $[2];
    T1 = $[3];
    active = $[4];
    t0 = $[5];
    t1 = $[6];
    t10 = $[7];
    t11 = $[8];
    t12 = $[9];
    t13 = $[10];
    t14 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  let t15;
  if ($[44] !== t0 || $[45] !== t1) {
    t15 = <ul className={t0}>{t1}</ul>;
    $[44] = t0;
    $[45] = t1;
    $[46] = t15;
  } else {
    t15 = $[46];
  }
  let t16;
  if ($[47] !== t15 || $[48] !== t2 || $[49] !== t3) {
    t16 = <div className={t2}>{t3}{t15}</div>;
    $[47] = t15;
    $[48] = t2;
    $[49] = t3;
    $[50] = t16;
  } else {
    t16 = $[50];
  }
  let t17;
  if ($[51] !== active.alt || $[52] !== active.image) {
    t17 = <div className="order-1 flex justify-center lg:order-2 lg:justify-end"><Image src={active.image} alt={active.alt} width={600} height={450} loading="lazy" className="w-full max-w-[600px] object-contain" /></div>;
    $[51] = active.alt;
    $[52] = active.image;
    $[53] = t17;
  } else {
    t17 = $[53];
  }
  let t18;
  if ($[54] !== T0 || $[55] !== t16 || $[56] !== t17 || $[57] !== t4 || $[58] !== t5 || $[59] !== t6 || $[60] !== t7 || $[61] !== t8 || $[62] !== t9) {
    t18 = <T0 key={t4} initial={t5} animate={t6} exit={t7} transition={t8} className={t9}>{t16}{t17}</T0>;
    $[54] = T0;
    $[55] = t16;
    $[56] = t17;
    $[57] = t4;
    $[58] = t5;
    $[59] = t6;
    $[60] = t7;
    $[61] = t8;
    $[62] = t9;
    $[63] = t18;
  } else {
    t18 = $[63];
  }
  let t19;
  if ($[64] !== T1 || $[65] !== t10 || $[66] !== t18) {
    t19 = <T1 mode={t10}>{t18}</T1>;
    $[64] = T1;
    $[65] = t10;
    $[66] = t18;
    $[67] = t19;
  } else {
    t19 = $[67];
  }
  let t20;
  if ($[68] !== t11 || $[69] !== t12 || $[70] !== t13 || $[71] !== t19) {
    t20 = <div className={t11}>{t12}{t13}{t19}</div>;
    $[68] = t11;
    $[69] = t12;
    $[70] = t13;
    $[71] = t19;
    $[72] = t20;
  } else {
    t20 = $[72];
  }
  let t21;
  if ($[73] !== t14 || $[74] !== t20) {
    t21 = <section className={t14}>{t20}</section>;
    $[73] = t14;
    $[74] = t20;
    $[75] = t21;
  } else {
    t21 = $[75];
  }
  return t21;
}
function _temp(point) {
  return <li key={point} className="rounded-[12px] bg-white px-7 py-6 shadow-[0_4px_24px_rgba(13,38,76,0.08)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_34px_rgba(13,38,76,0.12)] dark:bg-gray-800 dark:shadow-[0_4px_24px_rgba(0,0,0,0.4)]"><p className="font-poppins text-base font-bold leading-snug text-[#141047] lg:text-[17px] dark:text-white">{point}</p></li>;
}